module.exports = __webpack_public_path__ + "img/ps-35.67ba3883.jpg";